import { createUseStyles } from 'react-jss'
import { colors } from '../../variables.style'

export const style = {
  footer: {
    display: 'flex',
    width: '100%',
    fontSize: 12,
    alignItems: 'end',
    flexFlow: 'wrap'
  },
  logoAndCopyright: {
    flex: 1,
    textAlign: 'left',
    marginRight: 30
  },
  poweredLink: {
    color: colors.brandPrimary
  }
}

export const useStyles = createUseStyles(style)
